import News from './News';
import NewsList from './NewsList';
import NewsListItem from './NewsListItem';
import FullNewsWrapper from './FullNewsWrapper';

export default News;
export { NewsList, NewsListItem, FullNewsWrapper };
